import { defineMessages } from 'react-intl';

export const ACTION_PREFIX = '@@insurance';

export const ILL_CHOOSE_LATER_TEXT = 'I\'ll choose my insurance later';
export const IM_PAYING_MYSELF_TEXT = 'I\'m paying for myself';
export const IM_PAYING_MYSELF_CAPITALIZED_TEXT = 'I\'m Paying for Myself';

export const ROOT_STATE_KEY = 'insurance';

export const LOCALIZED_STRINGS = defineMessages({
    PAYING_MYSELF: {
        id: 'Components.InsurancePicker.PayingMyself',
        defaultMessage: 'I\'m paying for myself',
    },
    ILL_CHOOSE_LATER: {
        id: 'Components.InsurancePicker.IllChooseLater',
        defaultMessage: 'I\'ll choose my insurance later',
    },
    CHOOSE_INSURANCE: {
        id: 'Components.InsurancePicker.ChooseInsurance',
        defaultMessage: 'choose insurance',
    },
    CHOOSE_PLAN: {
        id: 'Components.InsurancePicker.ChoosePlan',
        defaultMessage: 'choose plan',
    },
});


export const CARRIER = {
    BLUE_CROSS_BLUE_SHIELD: '304',
    CARRIER_NOT_CHOSEN: '',
    ILL_CHOOSE_LATER: '-1',
    IM_PAYING_MYSELF: '-2',
};
// #endregion
